<template>
  <el-table
    :data="newList"
    height="300px">
    <el-table-column
      prop="idx"
      width="50">
    </el-table-column>
    <el-table-column
      prop="productName"
      label="商品名称">
    </el-table-column>
    <el-table-column
      width="80"
      prop="periodBeginStockQuantity"
      :formatter="row=> row.periodBeginStockQuantity + '件'"
      label="期初库存">
    </el-table-column>
    <el-table-column
      width="80"
      prop="periodEndStockQuantity"
      :formatter="row=> row.periodEndStockQuantity + '件'"
      label="期末库存">
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'StockTable',
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    newList() {
      return this.list.map((i, idx) => {
        return {
          ...i,
          idx: idx + 21
        }
      })
    }
  }
}
</script>

